import { Mail, Network } from 'lucide-react';

import OnesuranceIcon from '@/components/icons/Onesurance';
import cn from '@/lib/utils/cn';
import type { Action } from '@/types/actions';

type Props = {
  source: Action['source'];
  className?: string;
};

export default function ActionSourceIcon({ source, className }: Props) {
  return (
    <div
      className={cn(
        'text-primary-600 dark:text-primary-400 bg-primary-200/30 dark:bg-primary-500/30 absolute top-0 right-0 flex size-6 rounded-tr-md rounded-bl-md p-1.5',
        className,
      )}
    >
      {source === 'ONESURANCE' && <OnesuranceIcon className="size-3" />}
      {source === 'EMAIL' && <Mail className="size-3" strokeWidth={2.5} />}
      {source === 'PARTY_CHECKUP' && (
        <Network className="size-3" strokeWidth={2.5} />
      )}
    </div>
  );
}
